import React from 'react';

import { useSelector } from 'react-redux';

import { RdsIcon } from 'components/Icons';
import { AnalyzedCard } from 'containers/Visibility/Data/Components/Dashboard/Cards/AnalyzedCard';
import { selectDataDashboard } from 'containers/Visibility/Data/selectors';

export const DatabasesCard = () => {
  const {
    analyzedSources,
    summaryOfAllDataSources,
    sensitiveDataByAgnosticSources,
  } = useSelector(selectDataDashboard);
  const dataSources = summaryOfAllDataSources.data?.resource_type_counts;
  const sensitiveData = sensitiveDataByAgnosticSources.data;

  return (
    <AnalyzedCard
      label="Databases"
      isLoading={analyzedSources.isLoading}
      icon={<RdsIcon />}
      total={dataSources?.Databases ?? 0}
      analyzed={analyzedSources.data?.DB ?? 0}
      sensitiveDataCount={sensitiveData?.DB ?? 0}
    />
  );
};
